import {Opaque} from 'type-fest';

export const FARM_ID = Symbol('Farm ID');
export type FarmId = Opaque<number, typeof FARM_ID>;
export const SLOT_COUNT = Symbol('DetailSlot count');
export type SlotCount = Opaque<number, typeof SLOT_COUNT>;
